import React from "react";
import { useLanguage } from "../i18n/LanguageContext";

export const Ticker = () => {
  const { tRaw } = useLanguage();
  const base = tRaw("ticker") || [];
  const items = [...base, ...base, ...base];
  return (
    <div data-testid="ticker" className="relative border-y-2 border-[#FFEA00] bg-[#FFEA00] overflow-hidden">
      <div className="flex whitespace-nowrap marquee py-3">
        {items.map((t, i) => (
          <div key={i} className="flex items-center gap-6 px-6 font-display font-bold text-black text-base md:text-lg uppercase tracking-[0.15em]">
            <span>{t}</span>
            <span className="text-black/60">✦</span>
          </div>
        ))}
      </div>
    </div>
  );
};
